export const MESSAGING_SETTINGS_KEYWORDS_STATUS = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
};

export const BIRTHDAY_DEFINITION_SEND_STRATEGY = {
  ON_CONTACT_BIRTHDAY: 'ON_CONTACT_BIRTHDAY',
  DURING_BIRTHDAY_MONTH: 'DURING_BIRTHDAY_MONTH',
};
